import axios from "axios";
import { baseurl } from "domain";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Icon from "@mui/material/Icon";
import team2 from "assets/images/team-2.jpg";
import { useState } from "react";
import { Typography } from "@mui/material";
import {convertTo12Hour} from "utils/converterUtils"

// Define Author component
const Author = ({ image, name, email }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <MDAvatar src={image} name={name} size="sm" />
    <MDBox ml={2} lineHeight={1}>
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {name}
      </MDTypography>
      <MDTypography variant="button">{email}</MDTypography>
    </MDBox>
  </MDBox>
);

Author.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

// Define Job component
const Job = ({ title, description }) => (
  <MDBox lineHeight={1} textAlign="left">
    <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
      {title}
    </MDTypography>
    <MDTypography variant="caption">{description}</MDTypography>
  </MDBox>
);

Job.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

Job.defaultProps = {
  description: "",
};

async function authorsTableData(filters, handleClickView, handleClickDelete, handleEditClick) {
  let data = [];

  try {
    const response = await axios.post(`https://${baseurl}/filterCancelBookings`, filters);
    data = response.data.canceled_bookings;
  } catch (error) {
    console.error("Error fetching filtered data:", error);
  }
  var columns = [
    { Header: "Name", accessor: "Name", width: "20%", align: "left" },
    { Header: "Phone", accessor: "Phone", align: "left" },
    { Header: "Date", accessor: "Date", align: "center" },
    { Header: "Type", accessor: "Type", align: "center" },
    { Header: "Method", accessor: "Method", align: "center" },
    { Header: "Start", accessor: "Start", align: "center" },
    { Header: "End", accessor: "End", align: "center" },
    // { Header: "Edit", accessor: "Edit", align: "center" },
    { Header: "View", accessor: "View", align: "center" },
    // { Header: "Delete", accessor: "Delete", align: "center" },
  ];

  const rows = data
    .map((user) => ({
      Name: <Typography fontSize={"large"}><b>{user.name}</b></Typography>, 
      Phone: <Typography fontSize={"large"}>{user.phnNo}</Typography>,
      Date: <Typography fontSize={"large"}>{user.date}</Typography>,
      Type: <Typography fontSize={"large"}>{user.subCatType}</Typography>,
      Method: <Typography fontSize={"large"}>{user.bookedBy}</Typography>,
      Start: <Typography fontSize={"large"}>{convertTo12Hour(user.start_time)}</Typography>,
      End: <Typography fontSize={"large"}>{convertTo12Hour(user.end_time)}</Typography>,
      View: (
        <MDButton
          variant="text"
          color="primary"
          style={{ color: "blue" }}
          onClick={() => handleClickView(user.payment_id)}
        >
          <VisibilityIcon style={{ color: "blue" }} />
          &nbsp;view
        </MDButton>
      ),
      Delete: (
        <MDButton variant="text" color="error" onClick={() => handleClickDelete(user.uid)}>
          <Icon>delete</Icon>&nbsp;delete
        </MDButton>
      ),
      Edit: (
        <MDButton variant="text" color="dark" onClick={() => handleEditClick(user.payment_id)}>
          <Icon>edit</Icon>&nbsp;edit
        </MDButton>
      ),
    }));


  return { columns, rows };
}

export default authorsTableData;
